module.exports = __webpack_public_path__ + "img/sunburst-20231114.f11b752c.png";